// Mock data for VTC Fontainebleau website
export const vtcData = {
  contact: {
    name: "Moïse",
    phone: "06 69 47 52 16",
    email: "merisma.moise@gmail.com", // Pour Formspree uniquement
    location: "Fontainebleau"
  },
  
  services: [
    {
      id: 1,
      title: "Transferts Aéroports",
      description: "Transport vers tous les aéroports parisiens : CDG, Orly, Beauvais",
      icon: "Plane"
    },
    {
      id: 2,
      title: "Transferts Gares",
      description: "Liaisons vers toutes les gares : Gare du Nord, Gare de Lyon, etc.",
      icon: "Train"
    },
    {
      id: 3,
      title: "Lieux Touristiques", 
      description: "Visites et transferts vers châteaux, musées et sites touristiques",
      icon: "Camera"
    },
    {
      id: 4,
      title: "Établissements Médicaux",
      description: "Transport sécurisé vers hôpitaux, cliniques et centres de soins",
      icon: "Heart"
    },
    {
      id: 5,
      title: "Mise à Disposition",
      description: "Véhicule et chauffeur à votre disposition pour plusieurs heures",
      icon: "Clock"
    }
  ],
  
  advantages: [
    {
      id: 1,
      title: "Prix Fixé à l'Avance",
      description: "Tarification transparente sans surprise, devis gratuit"
    },
    {
      id: 2, 
      title: "Véhicule Confortable",
      description: "Berline récente, climatisée et spacieuse"
    },
    {
      id: 3,
      title: "Ponctualité Garantie",
      description: "Prise en charge à l'heure convenue, suivi du trafic"
    },
    {
      id: 4,
      title: "Chauffeur Professionnel",
      description: "Expérience, courtoisie et connaissance de la région"
    }
  ]
};

// Note: mockSubmitQuote function has been removed and replaced with real API integration